// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader{margin-top:-22px;margin-left:12px}", "",{"version":3,"sources":["webpack://./resources/insite/js/components/insite/input/afasCountrySelect.vue"],"names":[],"mappings":"AAAA,QACE,gBAAA,CACA,gBACF","sourcesContent":[".loader {\n  margin-top: -22px;\n  margin-left: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
